import React from 'react';

type Props = {
  canUndo: boolean;
  canRedo: boolean;
  onUndo: () => void;
  onRedo: () => void;
  /** 미러 보기 등: 키보드 단축키와 같이 실행 취소·다시 실행 비활성 */
  disabled?: boolean;
};

const ProgramToolbarUndoRedoButtons: React.FC<Props> = ({
  canUndo,
  canRedo,
  onUndo,
  onRedo,
  disabled = false,
}) => (
  <div className="cp-program-toolbar-undo-redo" role="group" aria-label="편집 실행 취소">
    <button
      type="button"
      className="cp-program-toolbar-undo-redo-btn"
      aria-label="되돌리기"
      title="되돌리기"
      disabled={disabled || !canUndo}
      onClick={onUndo}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M3 7v6h6" />
        <path d="M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13" />
      </svg>
    </button>
    <button
      type="button"
      className="cp-program-toolbar-undo-redo-btn"
      aria-label="다시 실행"
      title="다시 실행"
      disabled={disabled || !canRedo}
      onClick={onRedo}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M21 7v6h-6" />
        <path d="M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7" />
      </svg>
    </button>
  </div>
);

export default ProgramToolbarUndoRedoButtons;
